import $ from 'jquery';

(() => {
  const body = $('body');
  const profileModalContainer = $('.profile-modal-container');
  const qaContainer = $('.qa-container');

  // モーダルを開く中
  $(document).on('opening', '.remodal', function () {
    profileModalContainer.scrollTop(0);
    qaContainer.scrollTop(0);
  });

  // モーダルをクリックしたらスクロールとめる
  $(document).on('opened', '.modal-profile-qa', function (e) {
    body.addClass('over-flow--hidden');
  });

  // モーダルをクローズしたらスクロールできるように
  $(document).on('closing', '.modal-profile-qa', function (e) {
    body.removeClass('over-flow--hidden');
  });

})();
